enum SOURCE_CARTO {
  GEOJSON = "GEOJSON",
  OSM = "OSM",
  WMS = "WMS",
  WMTS = "WMTS",
  WFS = "WFS",
}

export default SOURCE_CARTO;
